
















import { Component, Vue, Prop } from "vue-property-decorator";
import { INews } from "@/api/types";
@Component
export default class Index extends Vue {
  @Prop()
  newsData!: INews;

  get imgList() {
    return this.newsData.images.indexOf(",") > -1
      ? this.newsData.images.split(",")
      : [this.newsData.images];
  }

  itemClick() {
    this.$emit("itemClick", this.newsData);
  }
}
